<template>
	<div class="horizontal-bar-chart">
		<chart-base :chart-options="options" :height="height" :width="width"></chart-base>
	</div>
</template>

<script>
import chartMixin, { getMax, getLabel } from './chartMixin.js'

export default {
	name: 'HorizontalBarChart',
	mixins: [chartMixin],
	computed: {
		options() {
			const label = getLabel(
				{
					position: 'right',
					distance: 7,
					align: 'left',
				},
				this.chartOptions.series,
			)
			const baseConfig = {
				color: [this.chartStyle === 'blue' ? 'rgba(17, 117, 232, 0.6)' : 'rgba(83, 94, 215, 0.6)'],
				xAxis: {
					type: 'value',
					axisLine: {
						show: true,
						lineStyle: {
							color: '#E8E8E8',
						},
					},
					axisTick: {
						show: false,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
						formatter: value => {
							if (value === 0) return '0'
							if (value > 1000) return `${(value / 1000).toFixed(1)}k`
							return value
						},
					},
					max: getMax,
					minInterval: 1,
					splitNumber: 4,
				},
				yAxis: {
					type: 'category',
					data: [],
					axisLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
				},
				series: [
					{
						type: 'bar',
						barWidth: 20,
						data: this.data,
						label,
					},
				],
			}

			const mergedOptions = this.mergeOptions(baseConfig, this.chartOptions)

			mergedOptions.series.push({
				type: 'pictorialBar',
				barWidth: 20,
				symbol: 'rect',
				symbolSize: [3, 20],
				symbolOffset: [3, 0],
				barGap: '-100%',
				symbolPosition: 'end',
				data: mergedOptions.series[0].data,
				itemStyle: {
					color: this.chartStyle === 'blue' ? 'rgba(17, 117, 232, 1)' : 'rgba(83, 94, 215, 1)',
				},
				z: 10,
				showLegendSymbol: false,
			})

			// 合并传入的配置
			return mergedOptions
		},
	},
}
</script>

<style lang="scss" scoped>
.horizontal-bar-chart {
	width: 100%;
	height: 100%;
}
</style>
